import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=d3aaa704&scoped=true&"
import script from "./tabs.ts?vue&type=script&lang=ts&"
export * from "./tabs.ts?vue&type=script&lang=ts&"
import style0 from "./tabs.scss?vue&type=style&index=0&id=d3aaa704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3aaa704",
  null
  
)

export default component.exports